import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-edit-group-details',
  templateUrl: './edit-group-details.component.html',
  styleUrls: ['./edit-group-details.component.scss'],
})
export class EditGroupDetailsComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
